import React, { useEffect, useState } from 'react';
import { AlertTriangle, X } from 'lucide-react';

const RejectModal = ({ reasons, onConfirm, onClose, isSubmitting }) => {
  const [reason, setReason] = useState(reasons?.[0] || '');
  const [note, setNote] = useState('');

  useEffect(() => {
    const handleKey = (e) => {
      if (e.key === 'Escape') onClose();
    };
    window.addEventListener('keydown', handleKey);
    return () => window.removeEventListener('keydown', handleKey);
  }, [onClose]);

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 p-4">
      <div className="w-full max-w-lg bg-white dark:bg-gray-800 rounded-lg shadow-2xl p-6">
        <div className="flex items-center justify-between mb-4">
          <h2 className="text-lg font-semibold text-gray-900 dark:text-white">
            Rejeitar foto
          </h2>
          <button onClick={onClose} className="p-1 text-gray-500 hover:text-gray-700">
            <X className="w-5 h-5" />
          </button>
        </div>

        <div className="flex items-start gap-2 p-3 mb-4 rounded-md border border-fire-300 bg-fire-50 dark:bg-fire-900/30 dark:border-fire-700">
          <AlertTriangle className="w-5 h-5 text-fire-600 dark:text-fire-300 flex-shrink-0 mt-0.5" />
          <p className="text-sm text-fire-800 dark:text-fire-100">
            Esta acção elimina a foto definitivamente do storage (MinIO) e da base de dados (MongoDB).
            <strong> Não é reversível.</strong>
          </p>
        </div>

        <div className="space-y-2 mb-4 max-h-64 overflow-y-auto">
          {reasons.map((r) => (
            <label
              key={r}
              className="flex items-center gap-2 p-2 rounded-md hover:bg-gray-50 dark:hover:bg-gray-700 cursor-pointer"
            >
              <input
                type="radio"
                name="reason"
                value={r}
                checked={reason === r}
                onChange={(e) => setReason(e.target.value)}
                className="text-fire-500"
              />
              <span className="text-sm text-gray-800 dark:text-gray-200">{r}</span>
            </label>
          ))}
        </div>

        <textarea
          value={note}
          onChange={(e) => setNote(e.target.value)}
          placeholder="Nota adicional (opcional)"
          rows={3}
          className="w-full p-2 border border-gray-300 dark:border-gray-600 rounded-md bg-white dark:bg-gray-700 text-sm text-gray-900 dark:text-white"
        />

        <div className="flex justify-end gap-2 mt-4">
          <button
            onClick={onClose}
            disabled={isSubmitting}
            className="px-4 py-2 rounded-md text-sm border border-gray-300 dark:border-gray-600 text-gray-700 dark:text-gray-200 hover:bg-gray-50 dark:hover:bg-gray-700"
          >
            Cancelar
          </button>
          <button
            onClick={() => onConfirm({ reason, note })}
            disabled={isSubmitting || !reason}
            className="px-4 py-2 rounded-md text-sm bg-fire-500 text-white hover:bg-fire-600 disabled:opacity-50"
          >
            {isSubmitting ? 'A rejeitar…' : 'Confirmar rejeição'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default RejectModal;
